export default "__VITE_ASSET__8b1f66de__"